import Api from './api';

const getProfitRequest = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/profit', {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}

const getProfitInvoicesRequest = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/profit/invoices', {
        headers: { Authorization: 'Bearer ' + access_token },
        params: query
    })
}

const downloadProfitInvoiceExportInExcelRequest = (query) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/profit/excel', {
        headers: { Authorization: 'Bearer ' + access_token },
        responseType: 'blob',
        params: query
    })
}

const getManagerGoalAchieved = () => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/profit/achieved', {
        headers: { Authorization: 'Bearer ' + access_token },
    })
}


export default {
    getProfitRequest,
    getProfitInvoicesRequest,
    downloadProfitInvoiceExportInExcelRequest,
    getManagerGoalAchieved
}



// WEBPACK FOOTER //
// ./src/api/apiProfit.js